import { render, staticRenderFns } from "./ArticleAccordionList.vue?vue&type=template&id=801bfea6&scoped=true"
import script from "./ArticleAccordionList.vue?vue&type=script&lang=js"
export * from "./ArticleAccordionList.vue?vue&type=script&lang=js"
import style0 from "./ArticleAccordionList.vue?vue&type=style&index=0&id=801bfea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801bfea6",
  null
  
)

export default component.exports